import { createFileRoute } from "@tanstack/react-router"

import { EducationStep } from "@/features/membership/application/components/education-step"

export const Route = createFileRoute("/membership/apply/education")({
  component: EducationStep,
})
